module.exports = __webpack_public_path__ + "static/media/welcome_image_one.eaa8e61d.jpg";